<template>
  <div class="sc item">
    <div :class="[ landscape ? 'top' : 'top-portrait']">
      <div class="lf">
        <img class="logo" src="../../assets/sc/logo.png" v-animate-css="logoIn" alt="">
        <img class="text" src="../../assets/sc/text.png" v-animate-css="textIn" alt="">
        <img class="bg" src="../../assets/sc/bg.png" v-animate-css="bgIn" alt="">
      </div>
      <div class="rt">
        <img class="en" src="../../assets/sc/en.png" alt="" v-animate-css="detailTextIn">
        <div class="line" v-animate-css="lineIn"></div>
        <p v-animate-css="detailText1In">软件咨询暨软件外包，是我们近几年的主要业务，主要客户和合作伙伴有湖南快乐芒果互娱、海尔智能家电、山东以太科技、青岛出版集团、青岛文明办等企业单位，也有小型的创业团队。我们开发的软件，从微信公众号到手机 App，从办公协作系统到千万人使用的晚会互动系统，都严格按期交付，并且上限后稳定高效，帮助各位合作伙伴带来了可观的回报。</p>
        <p v-animate-css="detailText2In">将业务流程利用软件系统落地是个非常复杂的过程，我们愿意以多年的软件技术经验帮助各位快速高效的落地，实现盈利，同时在软件开发过程管理、代码审查、安全测试、架构设计、技术运维上我们也会提供支持和培训服务。</p>
      </div>
    </div>
    <div class="paging">
      <div class="btn-left" @mouseover="showArrow('left')" @mouseout="hideArrow('left')" @click="slide(-1)"></div>
      <div class="paging-left" v-if="left"></div>
      <div class="paging-right" v-if="right"></div>
      <div class="page-num">3/3</div>
    </div>
    <div class="close" @click="routeTo('Dashboard')">
      <div class="btn-close"></div>
      <span>close</span>
    </div>
  </div>
</template>

<script>
import Config from './Config.js'
export default {
  mixins: [
    Config
  ]
}
</script>

<style lang="scss" scoped>
@import '../../Global.scss';
@import './Detail.scss';
.logo {
  width: 2.73rem;
  height: 1.51rem;
  left: 0.2rem;
  top: 1.7rem;
}
.bg {
  width: 6.37rem;
  height: 4rem;
  left: 0;
}
.text {
  width: 1.91rem;
  height: 3.11rem;
  top: 1.15rem;
  left: 2.1rem;
}
.en {
  width: 1.63rem;
  height: .185rem;
  display: block;
}
.paging {
  background-image: url('../../assets/sc/paging.png');
  .btn-left {
    width: 1.5rem;
  }
  .page-num {
    left: 1.55rem;
  }
  .paging-left {
    background-image: url('../../assets/sc/paging_l.png');
  }
  .paging-right {
    background-image: url('../../assets/sc/paging_r.png');
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Detail/Part3.vue